module.exports = __webpack_public_path__ + "static/media/thumb_up_with_start.ce544047.svg";